export default {
	"heroBackLink.to.default": "Zurück",
	"heroBackLink.to.home": "zurück zur Startseite",
} as const;
